module.exports = __webpack_public_path__ + "iPhone7-Silver-landscape.png?80cca5f11105169f462a7b863e006403";